<template>
    <v-container>
        <v-card class="pa-3 ma-3">
            <v-toolbar flat color="#1d2735" dark>
                <pre><v-toolbar-title><h2>Facturación</h2></v-toolbar-title></pre>
            </v-toolbar>

            <v-card-text>
                <!-- Ordenes de trabajo -->
                <v-row>
                    <v-col cols="12" md="8">
                        <filter-component-vue
                            :headers="filter_headers_ordenes"
                            v-model="filters_ordenes"
                        ></filter-component-vue>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-btn
                            color="primary"
                            class="white--text"
                            @click="
                                () => {
                                    page = 1;
                                    getOrdenes();
                                }
                            "
                        >
                            Filtrar
                        </v-btn>
                        <v-btn
                            color="red"
                            class="white--text"
                            @click="
                                filters_ordenes = {};
                                getOrdenes();
                            "
                        >
                            Limpiar filtros
                        </v-btn>
                    </v-col>
                    <v-col cols="12">
                        <v-toolbar dense elevation="0">
                            <v-row>
                                <v-icon class="mr-2">mdi-cash</v-icon>
                                <v-toolbar-title>Obras</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="primary"
                                    :disabled="disabled"
                                    @click="crearFacturaOrden()"
                                    >Crear factura/nota</v-btn
                                >
                            </v-row>
                        </v-toolbar>
                        <v-data-table
                            v-model="ordenes_selected"
                            :headers="headers_ordenes"
                            :items="ordenes"
                            item-key="id"
                            class="elevation-1"
                            show-select
                            :options.sync="options"
                            @update:options="onOptionsUpdate"
                            :server-items-length="totalOrdenes"
                            :loading="loading_ordenes"
                        >
                            <template v-slot:item.importe="{ item }">
                                {{ item.importe | format_precio }}
                            </template>
                            <template v-slot:item.facturada="{ item }">
                                <v-icon
                                    color="success"
                                    v-if="item.estado == 'Facturada'"
                                    >mdi-check-circle</v-icon
                                >
                                <v-icon color="error" v-else>mdi-cancel</v-icon>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>

                <hr class="mt-5 mb-5" />

                <!-- Albaranes -->
                <v-row>
                    <v-col cols="12" md="8">
                        <filter-component-vue
                            :headers="filter_headers_albaranes"
                            v-model="filters_albaranes"
                        ></filter-component-vue>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-btn
                            color="primary"
                            class="white--text"
                            @click="
                                () => {
                                    page = 1;
                                    getAlbaranes();
                                }
                            "
                        >
                            Filtrar
                        </v-btn>
                        <v-btn
                            color="red"
                            class="white--text"
                            @click="
                                filters_albaranes = {};
                                getAlbaranes();
                            "
                        >
                            Limpiar filtros
                        </v-btn>
                    </v-col>
                    <v-col cols="12">
                        <v-toolbar dense elevation="0">
                            <v-row>
                                <v-icon class="mr-2">mdi-playlist-check</v-icon>
                                <v-toolbar-title>Albaranes</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="primary"
                                    @click="crearFacturaAlbaran()"
                                    :disabled="disabled_2"
                                    >Crear factura</v-btn
                                >
                            </v-row>
                        </v-toolbar>

                        <v-data-table
                            v-model="albaranes_selected"
                            :headers="headers_albaranes"
                            :items="albaranes"
                            item-key="id"
                            class="elevation-1"
                            show-select
                            :options.sync="options_2"
                            @update:options="onOptionsUpdate_2"
                            :server-items-length="totalAlbaranes"
                            :loading="loading_albaranes"
                        >
                            <template v-slot:item.importe="{ item }">
                                {{ item.importe | format_precio }}
                            </template>
                            <template v-slot:item.facturada="{ item }">
                                <v-icon color="success" v-if="item.facturada"
                                    >mdi-check-circle</v-icon
                                >
                                <v-icon color="error" v-else>mdi-cancel</v-icon>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <!-- Dialog de mensaje de aviso de creacion de factura(s) ccon importe 0 -->
        <MessageDialog
            v-model="isMessageDialogVisible"
            title="Aviso"
            :content="message"
            @submit="confirm"
        />

        <!-- Dialog de configuracion de fecha y fecha de finalizacion de factura -->
        <CustomDialog
            v-model="isCustomDialogVisible"
            title="Detalles de facturación"
            @submit="save"
        >
            <v-row>
                <v-col cols="12" md="6">
                    <dateSelect label="Fecha" v-model="factura.fecha" />
                </v-col>
                <v-col cols="12" md="6">
                    <dateSelect
                        label="Fecha de vencimiento"
                        v-model="factura.fecha_vencimiento"
                    />
                </v-col>
            </v-row>
        </CustomDialog>
    </v-container>
</template>
<script>
import FilterComponentVue from "../../../components/general/FilterComponent.vue";
import { addDays, currentDay } from "../../../components/general/DateFunctions";
import { addFacturaAnticipoNegativa } from "../../factura/js/Anticipo";
import CustomDialog from "../../../components/general/dialogs/CustomDialog.vue";
import MessageDialog from "../../../components/general/dialogs/MessageDialog.vue";
import dateSelect from "../../../components/general/dateSelect.vue";

export default {
    components: {
        FilterComponentVue,
        CustomDialog,
        MessageDialog,
        dateSelect,
    },
    data() {
        return {
            isMessageDialogVisible: false,
            message: "",

            isCustomDialogVisible: false,

            loading_ordenes: false,
            ordenes_selected: [],
            headers_ordenes: [
                { text: "Nº Obra", value: "nro_orden", sortable: false },
                { text: "Cliente", value: "nombre_cliente", sortable: false },
                {
                    text: "Fecha de finalización",
                    value: "fecha_finalizada",
                    sortable: false,
                },
                {
                    text: "Importe",
                    value: "importe",
                    sortable: false,
                    align: "center",
                },
                {
                    text: "Nº Presupuesto asociado",
                    value: "id_presupuesto",
                    align: "center",
                },
                { text: "Estado", value: "estado", sortable: false },
                { text: "Facturada", value: "facturada", align: "center" },
            ],
            ordenes: [],
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
                sortDesc: [],
            },
            totalOrdenes: 0,
            filter_headers_ordenes: [
                {
                    title: "Fecha",
                    type: "date",
                    active: false,
                    model: "fecha",
                },
                {
                    title: "Cliente",
                    type: "cliente",
                    active: false,
                    model: "id_cliente",
                },
                {
                    title: "Presupuesto",
                    type: "presupuesto",
                    active: false,
                    model: "id_presupuesto",
                },
                {
                    title: "Obra",
                    type: "ordenes",
                    active: false,
                    model: "id_orden",
                },
                {
                    title: "Facturadas",
                    type: "check",
                    active: false,
                    model: "facturada",
                    default_value: false,
                },
                {
                    title: "Finalizadas",
                    type: "check",
                    active: false,
                    model: "atendida", // en este caso atendida = finalizada
                    default_value: true,
                },
            ],
            filters_ordenes: {},
            disabled: false,

            // ---------------------------- //
            loading_albaranes: false,
            albaranes_selected: [],
            headers_albaranes: [
                { text: "Nº Albarán", value: "nro", sortable: false },
                { text: "Cliente", value: "nombre_cliente", sortable: false },
                { text: "Fecha", value: "fecha", sortable: false },
                {
                    text: "Importe",
                    value: "importe",
                    sortable: false,
                    align: "center",
                },
                { text: "Facturada", value: "facturada", align: "center" },
            ],
            albaranes: [],
            options_2: {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
                sortDesc: [],
            },
            totalAlbaranes: 0,
            filter_headers_albaranes: [
                {
                    title: "Fecha",
                    type: "date",
                    active: false,
                    model: "fecha",
                },
                {
                    title: "Cliente",
                    type: "cliente",
                    active: false,
                    model: "id_cliente",
                },
                {
                    title: "Albarán",
                    type: "albaran_venta",
                    active: false,
                    model: "id_albaran_venta",
                    item_text: "nombre",
                    item_value: "id",
                },
                {
                    title: "Facturadas",
                    type: "check",
                    active: false,
                    model: "facturada",
                    default_value: false,
                },
            ],
            filters_albaranes: {},
            disabled_2: false,

            // ---------------------------- //
            factura: {
                id: null,
                lineas: [],
                manual: true,
                id_presupuesto: null,
                id_serie: null,
                id_cliente: null,
                id_metodo_pago: 1, // transferencia bancaria
                fecha: currentDay(),
                fecha_vencimiento: currentDay(),
                observaciones: "",
                observaciones_internas: "",
                nota: 0,
                total: 0,
            },
            lineas_factura: [],
            lineas_nota: [],
            tipo: null,
        };
    },
    created() {
        //NOTA: COMO YA NO SE REDIRIGIRA AL FORMULARIO DE FACTURA SINO QUE ESTA SERA CREADA AUTOMATICAMENTE DESDE AQUI,
        //      NO ES NECESARIO EL USO DE ESTADOS DE VUEX POR LO CUAL FUERON COMENTADAS LAS LINEAS DE CODIGO QUE LO INCLUIAN.
        //      ESTOS PUEDEN ELIMINARSE SI LO CONSIDERA PRECISO. EN ESTE MOMENTO NO FUERON ELIMINADOS DEBIDO A QUE CONSTANTEMENTE
        //      SE SOLICITARON CAMBIOS SOBRE SU FUNCIONAMIENTO Y CONSIDERE PERTINENTE MANTENERLOS "POR SI ACASO",
        //      A MODO DE RECUPERARLOS DE SER NECESARIO
        // this.$store.dispatch('clearOrdenesData')
        // this.$store.dispatch('clearAlbaraVentaData')
    },
    methods: {
        async confirm() {
            this.factura.id_cliente = this.ordenes_selected[0].id_cliente;
            this.factura.observaciones_internas =
                'Factura creada desde modulo "Facturación" seleccionando una o varias obras';
            for (const element of this.ordenes_selected) {
                let linea = this.clearLinea();

                linea.id_orden = element.id;
                const fecha_finalizada =
                    element.fecha_finalizada != null
                        ? new Date(
                              element.fecha_finalizada
                          ).toLocaleDateString()
                        : "Sin Asignar";
                linea.descripcion = `Nº de obra ${element.nro_orden} ${
                    element.id_presupuesto == null
                        ? ""
                        : ` Nº de presupuesto ${element.id_presupuesto}`
                } Fecha de finalización ${fecha_finalizada}`;
                element.lineas_presupuesto.forEach((element) => {
                    linea.descripcion += `\n- ${element?.denominacion}: ${element?.descripcion}`;
                });
                linea.precio = element.importe;
                const subtotal = linea.cantidad * linea.precio;
                linea.total = subtotal - linea.dcto;

                // Verifica si la línea ya existe antes de hacer push
                const lineaExiste = this.factura.lineas.find(
                    (l) =>
                        l.descripcion === linea.descripcion &&
                        l.cantidad === linea.cantidad &&
                        l.precio === linea.precio &&
                        l.id_orden === linea.id_orden
                );

                if (!lineaExiste) {
                    this.factura.lineas.push(linea);
                    await addFacturaAnticipoNegativa(
                        this.factura.lineas,
                        element.id_presupuesto,
                        "factura"
                    );
                }
            }
            await this.saveFactura(0);
            this.isMessageDialogVisible = false;
        },
        async save() {
            if (this.tipo == 0) {
                if (this.lineas_nota.length > 0) {
                    await this.setFacturaONota(1);
                    await this.saveFactura(0);
                    // this.clearFactura(0);
                }
                if (this.lineas_factura.length > 0) {
                    await this.setFacturaONota(0);
                    await this.saveFactura(0);
                    // this.clearFactura(0);{
                }

                this.clearFactura(0);
                this.lineas_factura = [];
                this.lineas_nota = [];
            } else {
                await this.saveFactura(1);
            }
        },
        openCustomDialog(tipo) {
            this.tipo = tipo;
            this.isCustomDialogVisible = true;
        },

        // ------ Ordenes de trabajo --------- //
        getOrdenes() {
            this.loading_ordenes = true;
            let filtros = this.filters_ordenes_string;

            axios
                .get(
                    `api/facturacion/ordenes?page=${this.options.page}&rowsPerPage=${this.options.itemsPerPage}${filtros}`
                )
                .then((res) => {
                    const response = res.data;
                    this.ordenes = response.data;
                    this.totalOrdenes = response.total;
                    this.loading_ordenes = false;
                })
                .catch((error) => {
                    console.log("error", error);
                    this.$toast.error(error.response);
                });
        },
        onOptionsUpdate(newOptions) {
            this.options = newOptions;
            this.getOrdenes();
        },
        async crearFacturaOrden() {
            if (this.ordenes_selected.length > 0) {
                this.disabled = false;
                const data = this.ordenes_selected;

                let id_cliente = null;
                let hasDifferentClientes = false;
                this.ordenes_selected.forEach((element) => {
                    if (id_cliente == null) {
                        id_cliente = element.id_cliente;
                    }
                    if (id_cliente != element.id_cliente) {
                        hasDifferentClientes = true;
                    }
                });

                if (hasDifferentClientes) {
                    this.$toast.error(
                        "Las órdenes deben pertenecer a un mismo cliente"
                    );
                    return;
                }

                await this.setFacturaLineas(data);

                if (
                    this.lineas_nota.length == 0 &&
                    this.lineas_factura.length == 0
                ) {
                    this.message =
                        "Todas Las obras seleccionadas tienen importe 0. ¿Está seguro de crear facturas?";
                    this.isMessageDialogVisible = true;
                    return;
                }

                /*if(this.lineas_nota.length > 0){
                    await this.setFacturaONota(1);
                    // await this.saveFactura(0);
                    // this.clearFactura(0);
                }else if(this.lineas_factura.length > 0){
                    await this.setFacturaONota(0);
                    // await this.saveFactura(0);
                    // this.clearFactura(0);{
                }else{
                    // this.$toast.error('No es posible crear una factura cuya orden seleccionada tenga importe 0')
                    this.message = 'Todas Las ordenes de trabajo seleccionadas tienen importe 0. ¿Esta seguro de crear facturas?'
                    this.isMessageDialogVisible = true;
                }*/

                this.openCustomDialog(0);

                // Guardar datos en Vuex
                // this.$store.dispatch('setOrdenesData', data);
                // this.$router.push('/guardar-factura')
            } else {
                this.disabled = true;
                this.$toast.error("Debe seleccionar al menos una obra");
            }
        },

        // ------- Albaranes --------- //
        getAlbaranes() {
            this.loading_albaranes = true;
            // let filtros = this.filters_albaranes_string

            axios
                .get(`api/albaran/venta`, {
                    params: {
                        page: this.options_2.page,
                        rowsPerPage: this.options_2.itemsPerPage,
                        ...this.filtersAlbaranesParams,
                    },
                })
                .then((res) => {
                    const response = res.data.success;
                    this.albaranes = response.data;
                    this.totalAlbaranes = response.total;
                    this.loading_albaranes = false;
                })
                .catch((error) => {
                    console.log("error", error);
                    this.$toast.error(error.response);
                });
        },
        onOptionsUpdate_2(newOptions) {
            this.options_2 = newOptions;
            this.getAlbaranes();
        },
        async crearFacturaAlbaran() {
            if (this.albaranes_selected.length > 0) {
                this.disabled_2 = false;
                const data = this.albaranes_selected;

                let id_cliente = null;
                let hasDifferentClientes = false;
                this.albaranes_selected.forEach((element) => {
                    if (id_cliente == null) {
                        id_cliente = element.id_cliente;
                    }
                    if (id_cliente != element.id_cliente) {
                        hasDifferentClientes = true;
                    }
                });

                if (hasDifferentClientes) {
                    this.$toast.error(
                        "Los albaranes deben pertenecer a un mismo cliente"
                    );
                    return;
                }

                this.setFactura(data, 1); // tipo 1 = albaran de venta
                // this.$nextTick(() => {
                // Asegurarse de que la factura esté completamente establecida
                // await this.saveFactura(1);
                this.openCustomDialog(1);
                // });

                // Guardar datos en Vuex
                // this.$store.dispatch('setAlbaranVentaData', data);
                // this.$router.push('/guardar-factura')
            } else {
                this.disabled_2 = true;
                this.$toast.error("Debe seleccionar al menos un albarán");
            }
        },

        // Metodos auxiliares
        setFactura(items_slected, tipo) {
            if (this.tipo == null) {
                this.tipo = tipo;
            }
            if (this.tipo != tipo) {
                this.clearFactura(tipo);
            }

            this.factura.id_cliente = items_slected[0].id_cliente;

            for (const element of items_slected) {
                let linea = {
                    id: null,
                    descripcion: "",
                    articulo: null,
                    cantidad: 1,
                    precio: 0,
                    dcto: 0,
                    id_orden: null,
                    id_albaran_venta: null,
                    total: 0,
                };

                if (tipo == 0) {
                    // Si tipo = 0 establece la factura segun ordenes seleccionadas
                    linea.id_orden = element.id;
                    linea.precio = element.importe;
                    const subtotal = linea.cantidad * linea.precio;
                    linea.total = (subtotal - linea.dcto) * 1.21;

                    const fecha_finalizada =
                        element.fecha_finalizada != null
                            ? new Date(
                                  element.fecha_finalizada
                              ).toLocaleDateString()
                            : "Sin Asignar";

                    linea.descripcion = `Nº de obra ${element.nro_orden} ${
                        element.id_presupuesto == null
                            ? ""
                            : ` Nº de presupuesto ${element.id_presupuesto}`
                    } Fecha de finalización ${fecha_finalizada}`;
                    element.lineas_presupuesto.forEach((element) => {
                        linea.descripcion += `\n- ${element?.denominacion}: ${element?.descripcion}`;
                    });
                } else {
                    // en caso contrario establece la factura segun albaranes seleccionados
                    linea.id_albaran_venta = element.id;
                    const total = element.importe;
                    linea.precio = total / (1 + 21 / 100); // Las facturas realizan el calculo del total con el 21% del IVA directamente por lo que
                    // se realizo el calculo del total del albaran menos el 21% para que coincidieran los numeros
                    linea.total = total - linea.dcto;
                    const fecha =
                        element.fecha != null
                            ? new Date(element.fecha).toLocaleDateString()
                            : "Sin Asignar";
                    linea.descripcion = `Nº de albarán ${element.nro} - Fecha ${fecha}`;
                }

                // Verifica si la línea ya existe antes de hacer push
                const lineaExiste = this.factura.lineas.find(
                    (l) =>
                        l.descripcion === linea.descripcion &&
                        l.cantidad === linea.cantidad &&
                        l.precio === linea.precio &&
                        l.id_orden === linea.id_orden &&
                        l.id_albaran_venta === linea.id_albaran_venta
                );

                if (!lineaExiste) {
                    this.factura.lineas.push(linea);
                }
            }

            if (tipo == 0) {
                this.factura.observaciones_internas =
                    'Factura creada desde módulo "Facturación" seleccionando una o varias obras';
            } else {
                this.factura.observaciones_internas =
                    'Factura creada desde módulo "Facturación" seleccionando uno o varios albaranes de venta';
            }

            let total = 0;
            this.factura.lineas.forEach((elemento) => {
                total += elemento.total;
            });
            this.factura.total = total;

            console.log(
                tipo == 0
                    ? "factura según órdenes:"
                    : "factura según albaranes:",
                this.factura
            );
        },
        async setFacturaLineas(items_selected) {
            this.factura.id_cliente = items_selected[0].id_cliente;
            this.factura.observaciones_internas =
                'Factura creada desde módulo "Facturación" seleccionando uno o varias obras';

            for (const element of items_selected) {
                let linea = this.clearLinea();

                linea.id_orden = element.id;
                const fecha_finalizada =
                    element.fecha_finalizada != null
                        ? new Date(
                              element.fecha_finalizada
                          ).toLocaleDateString()
                        : "Sin Asignar";
                linea.descripcion = `Nº de obra ${element.nro_orden} ${
                    element.id_presupuesto == null
                        ? ""
                        : ` Nº de presupuesto ${element.id_presupuesto}`
                } Fecha de finalización ${fecha_finalizada}`;
                element.lineas_presupuesto.forEach((element) => {
                    linea.descripcion += `\n- ${element?.denominacion}: ${element?.descripcion}`;
                });
                if (element.importe_nota > 0) {
                    //linea = this.clearLinea()

                    linea.precio = element.importe_nota;
                    const subtotal = linea.cantidad * linea.precio;
                    linea.total = subtotal - linea.dcto;

                    // Verifica si la línea ya existe antes de hacer push
                    const lineaExiste = this.lineas_nota.find(
                        (l) =>
                            l.descripcion === linea.descripcion &&
                            l.cantidad === linea.cantidad &&
                            l.precio === linea.precio &&
                            l.id_orden === linea.id_orden
                    );

                    if (!lineaExiste) {
                        this.lineas_nota.push(linea);
                        await addFacturaAnticipoNegativa(
                            this.lineas_nota,
                            element.id_presupuesto,
                            "nota"
                        );
                    }
                }

                if (element.importe_factura > 0) {
                    linea = JSON.parse(JSON.stringify(linea));

                    linea.precio = element.importe_factura;
                    const subtotal = linea.cantidad * linea.precio * 1.21;
                    linea.total = subtotal - linea.dcto;

                    // Verifica si la línea ya existe antes de hacer push
                    const lineaExiste = this.lineas_factura.find(
                        (l) =>
                            l.descripcion === linea.descripcion &&
                            l.cantidad === linea.cantidad &&
                            l.precio === linea.precio &&
                            l.id_orden === linea.id_orden
                    );

                    if (!lineaExiste) {
                        this.lineas_factura.push(linea);
                        await addFacturaAnticipoNegativa(
                            this.lineas_factura,
                            element.id_presupuesto,
                            "factura"
                        );
                    }
                }
            }
        },
        async setFacturaONota(nota) {
            if (nota === 1) {
                this.factura.nota = 1;
                this.factura.id_metodo_pago = 3; // Efectivo
                this.factura.lineas = this.lineas_nota;
            } else {
                this.factura.nota = 0;
                this.factura.id_metodo_pago = 1; // Transferencia
                this.factura.lineas = this.lineas_factura;
            }

            let total = 0;
            this.factura.lineas.forEach((elemento) => {
                total += elemento.total;
            });
            this.factura.total = total;
        },
        clearLinea() {
            let linea = {
                id: null,
                descripcion: "",
                articulo: null,
                cantidad: 1,
                precio: 0,
                dcto: 0,
                id_orden: null,
                id_albaran_venta: null,
                tipo_hora: null,
                total: 0,
            };
            return linea;
        },
        async saveFactura(tipo) {
            console.log("factura", this.factura);
            try {
                const res = await axios.post("api/save-factura", this.factura);
                if (tipo == 0) {
                    this.getOrdenes();
                    this.isCustomDialogVisible = false;
                    this.$toast.success(
                        "Factura con las órdenes seleccionadas creada con éxito"
                    );
                } else {
                    this.getAlbaranes();
                    this.isCustomDialogVisible = false;
                    this.$toast.success(
                        "Factura con los albaranes de venta seleccionados creada con éxito"
                    );
                }
            } catch (error) {
                this.$toast.error(
                    error?.response?.data.mensaje ?? "Error inesperado"
                );
            }
        },
        clearFactura(tipo) {
            this.factura = {
                id: null,
                lineas: [],
                manual: true,
                id_presupuesto: null,
                id_serie: null,
                id_cliente: null,
                id_metodo_pago: 1,
                fecha: currentDay(),
                fecha_vencimiento: currentDay(),
                observaciones: "",
                observaciones_internas: "",
                nota: 0,
                total: 0,
            };

            this.tipo = tipo;
        },
    },
    watch: {
        options: {
            handler() {
                this.getOrdenes();
            },
            deep: true,
        },
        options_2: {
            handler() {
                this.getAlbaranes();
            },
            deep: true,
        },
        ordenes_selected: function (val) {
            val.length > 0 ? (this.disabled = false) : (this.disabled = true);
        },
        albaranes_selected: function (val) {
            val.length > 0
                ? (this.disabled_2 = false)
                : (this.disabled_2 = true);
        },
    },
    computed: {
        filters_ordenes_string() {
            let filtros = "";
            if (
                this.filters_ordenes.search != null &&
                this.filters_ordenes.search != ""
            ) {
                filtros += `&busqueda=${this.filters_ordenes.search}`;
            }
            this.filter_headers_ordenes.forEach((head) => {
                if (this.filters_ordenes[head.model]) {
                    if (head.type == "date") {
                        if (
                            this.filters_ordenes[head.model].start != "" &&
                            this.filters_ordenes[head.model].start != null
                        ) {
                            filtros += `&${head.model}_desde=${
                                this.filters_ordenes[head.model].start
                            }`;
                        }
                        if (
                            this.filters_ordenes[head.model].end != "" &&
                            this.filters_ordenes[head.model].end != null
                        ) {
                            filtros += `&${head.model}_hasta=${
                                this.filters_ordenes[head.model].end
                            }`;
                        }
                    } else if (
                        (this.filters_ordenes[head.model].value != "" &&
                            this.filters_ordenes[head.model].value != null) ||
                        (this.filters_ordenes[head.model].nombre != "" &&
                            this.filters_ordenes[head.model].nombre != null)
                    ) {
                        filtros += `&${head.model}=${
                            this.filters_ordenes[head.model].value
                        }`;
                    }
                    // }
                }
            });

            return filtros;
        },
        filtersAlbaranesParams() {
            let params = {};

            if (this.filters_albaranes.search) {
                params.search = this.filters_albaranes.search;
            }

            this.filter_headers_albaranes.forEach((head) => {
                if (this.filters_albaranes[head.model]) {
                    if (head.type == "date") {
                        if (this.filters_albaranes[head.model].start) {
                            params[`${head.model}_desde`] =
                                this.filters_albaranes[head.model].start;
                        }
                        if (this.filters_albaranes[head.model].end) {
                            params[`${head.model}_hasta`] =
                                this.filters_albaranes[head.model].end;
                        }
                    } else if (
                        this.filters_albaranes[head.model].value ||
                        this.filters_albaranes[head.model].nombre
                    ) {
                        params[head.model] =
                            this.filters_albaranes[head.model].value ||
                            this.filters_albaranes[head.model].nombre;
                    }
                }
            });

            return params;
        },
    },
};
</script>
